import React, { FC, useState } from 'react';
import Text from '@components/common/text';
import Button from '@components/common/button';
import Icon from '@components/common/assets';
import { useApplicationPositionList } from '@repository/match';
import HiddenPositionModal from './hiddenPositionModal';
import ApplyTab from './tab';
import SelectModal from './selectModal';
import { MatchingApplicationStatusType } from '@domain/rs/match/MatchingHomeApplicationPositionRs';
import { FontStyle } from '@domain/constant/fontStyle';
import Colors from '@domain/constant/colors';
import useModals from '@utils/hooks/useModals';
import classnames from 'classnames/bind';
import styles from './applyStatus.module.scss';
const cx = classnames.bind(styles);

const ApplyStatus: FC = () => {
  const { openModal, closeModal, isVisible } = useModals(['HIDDEN', 'SELECT']);
  const [tabType, setTabType] = useState<MatchingApplicationStatusType>('ALL');
  const { data } = useApplicationPositionList('ALL');
  const disabled = !data?.length;

  return (
    <>
      <div className={cx('wrap')}>
        <div className={cx('titleArea')}>
          <Text fontStyle={FontStyle.H4_B}>지원현황</Text>

          <div className={cx('btnArea')}>
            <Button
              theme="secondary"
              fontStyle={FontStyle.B4_B}
              onClick={() => openModal('HIDDEN')}
              styles={{ padding: '8px 16px', marginRight: '8px' }}
            >
              숨긴 내역 확인
            </Button>
            <Button
              theme="secondary"
              fontStyle={FontStyle.B4_B}
              onClick={() => openModal('SELECT')}
              styles={{ padding: '4px 18px 4px 12px' }}
              disabled={disabled}
            >
              <Icon
                name="download"
                width={24}
                height={24}
                fill={disabled ? Colors.C_COOL_GRAY_60 : Colors.C_JOBDA_BLACK}
              />
              <span style={{ marginLeft: '4px' }}>취업활동 증명서</span>
            </Button>
          </div>
        </div>

        <ApplyTab tabType={tabType} setTabType={setTabType} />
      </div>

      <HiddenPositionModal visible={isVisible('HIDDEN')} onClose={closeModal} tabType={tabType} />
      <SelectModal visible={isVisible('SELECT')} onClose={closeModal} />
    </>
  );
};

export default ApplyStatus;
